import { DayHour, MinuteNumber } from '@iotv/iotv-v3-types'
import { RulesetContent, RulesetDefintionType, RulesetType, Template } from '../ModelClassInterfaces'
import { PossibleBusinessObject } from '../types'
import { UserAttributeDefs } from '../types/ModelTypes'
import { TimeBucketUnits } from '../util'
import { ModelCommon } from './ModelCommon'

const typeName = 'Ruleset'

class Ruleset extends ModelCommon implements RulesetType {
  /**
   * Currently, can't inherit from `Thing`, as the constructor just expects `ob`
   * A consequence of `can't use prototype.constructor.name in Webpack`
   */
  constructor(ob: PossibleBusinessObject & Partial<RulesetType>) {
    super(typeName, ob)
    /** CRA — 2025 05: Possible deprecatable? */
    this.Group = ob.Group ?? undefined
    this.global = ob.global ?? false
    this.definition = ob.definition ?? {
      BooleanRule: [],
      MetricRule: [],
      GeofenceRule: undefined,
    }
    this.possibleAppliesToTypes = ob.possibleAppliesToTypes ?? []
    this.globallyApplyToObjectTypeId = ob.globallyApplyToObjectTypeId ?? false
    this.validBetween = ob.validBetween
    this.appliesToType = ob.appliesToType ?? undefined
    this.rulesetContent = ob.rulesetContent ?? RulesetContent.GEOFENCE_AND_METRIC
    this.setOperation = ob.setOperation
    this.messageTemplate = ob.messageTemplate
    this.escalationTemplate = ob.escalationTemplate
    this.period = ob.period
    this.unit = ob.unit
  }

  global: boolean

  definition: RulesetDefintionType = {
    BooleanRule: [],
    MetricRule: [],
    /** @deprecated */
    GeofenceRule: undefined,
  }
  setOperation?: 'AND' | 'OR' | undefined
  appliesToType: string | undefined
  /** @deprecated */
  possibleAppliesToTypes: string[] = []
  globallyApplyToObjectTypeId: boolean
  validBetween?: { from: { hour: DayHour; minute: MinuteNumber }; to: { hour: DayHour; minute: MinuteNumber } } | undefined
  /** @deprecated */
  rulesetContent: RulesetContent
  messageTemplate?: Template | undefined
  escalationTemplate?: Template | undefined
  period?: number | undefined
  unit?: TimeBucketUnits | undefined

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      appliesToType: {
        type: 'Enum',
        label: 'Applies to type',
        enumKv: this.possibleAppliesToTypes ? Object.fromEntries(this.possibleAppliesToTypes.map((v) => [v, v])) : {},
        editable: true,
      },
      globallyApplyToObjectTypeId: {
        type: 'Boolean',
        label: 'Always Apply To Type',
        editable: true,
      },
      RulesetBooleanRule: {
        type: 'Derived',
        label: 'Device Status Parameters',
        actions: {
          create: true,
          link: false,
          delete: true,
          edit: true,
        },
        valueFn: (state: any, functions: { [k: string]: Function }, accessKey?: string) => {
          return { state, functions, BooleanRule: this.definition.BooleanRule }
        },
        viewName: 'RulesetBooleanRule',
      },
      RulesetMetricRule: {
        type: 'Derived',
        label: 'Device Measurement Parameters',
        actions: {
          create: true,
          link: false,
          delete: true,
          edit: true,
        },
        valueFn: (state: any, functions: { [k: string]: Function }, accessKey?: string) => {
          return { state, functions, MetricRule: this.definition.MetricRule }
        },
        viewName: 'RulesetMetricRule',
      },
    }
  }
}

export { Ruleset }
